import React, { Component } from 'react'
import { connect } from 'react-redux'

import { postChatMessage, postChatImage } from '../../actions'

export class ChatForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      message: '',
      image: '',
      imageURL: '',
      image_error: ''
    }
  }

  _handleMessageChange (e) {
    this.setState({ message: e.target.value })
  }
  _handleImageChange (e) {
    const image = e.target.files[0]
    console.log(image)
    if (image) {
      if (
        (image.type === 'image/png' || image.type === 'image/jpeg' || image.type === 'image/jpeg') &&
        (image.name.indexOf('png') > 0 || image.name.indexOf('jpeg') > 0 || image.name.indexOf('jpg') > 0)
      ) {
        this.setState({ image, imageURL: URL.createObjectURL(image), image_error: '' })
        // Send image to cloud storage
        this.props.postChatImage(image, this.props.roomID)
      } else {
        this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }
  _handleMessageSubmit (e) {
    e.preventDefault()
    if (this.state.message) {
      const data = {
        message: this.state.message,
        type: 'default'
      }
      this.props.postChatMessage(data, this.props.roomID)
      this.setState({
        message: '',
        image: '',
        imageURL: '',
        image_error: ''
      })
      const chatList = document.querySelector('.chat_messages')
      chatList.scrollTop = chatList.scrollHeight
    }
  }

  render () {
    return (
      <form className="chat_input_section" onSubmit={this._handleMessageSubmit.bind(this)}>
        <div className="chat_input_header flex justify-between align-center">
          <div className="image_input flex">
            <input type="file" id="send_image_btn" onChange={this._handleImageChange.bind(this)}/>
            <label htmlFor="send_image_btn">
              <svg
                className="input_img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 46 46"
              >
                <path d="M46.7,10.041l-8.5-.559c-.745-.056-.727-.037-.782-.745-.13-2.086-.261-4.173-.41-6.278C36.961,1.639,36.886.82,36.83,0Q18.387,1.257,0,2.515c.8,11.2,1.6,22.337,2.4,33.5.838-.075,1.6-.13,2.4-.186-.2,2.794-.41,5.514-.633,8.271,13.413.931,26.789,1.882,40.2,2.813Q45.633,28.466,46.89,10.1C46.816,10.078,46.76,10.06,46.7,10.041ZM4.974,33.216c-.019.3-.037.578-.075.913-.168.019-.335.056-.484.075-.168.019-.335.037-.578.075C3.148,24.237,2.44,14.233,1.751,4.154c11.178-.8,22.318-1.6,33.57-2.4.168,2.515.354,5.011.522,7.564-.578-.037-1.118-.075-1.714-.112-.149-1.882-.279-3.726-.428-5.645-10,.689-19.971,1.4-30.031,2.086.093,1.379.168,2.7.261,4.005.168,2.515.354,5.011.522,7.526.2,3.018.373,6.036.633,9.054A48.552,48.552,0,0,1,4.974,33.216ZM32.266,5.328c.075,1.267.149,2.5.224,3.8-8.551-.6-17.083-1.192-25.671-1.788-.242,2.962-.466,5.868-.708,8.774H6.017c-.2-2.943-.391-5.887-.6-8.9C14.382,6.576,23.305,5.961,32.266,5.328ZM42.848,45.176C30.5,44.3,18.2,43.425,5.831,42.55Q6.977,25.839,8.141,9.091c12.37.876,24.665,1.733,37.017,2.608C44.394,22.877,43.63,34,42.848,45.176Zm.5-31.968c-11.2-.764-22.318-1.528-33.5-2.31C9.333,18.741,8.812,26.51,8.29,34.334c11.159.764,22.262,1.528,33.4,2.31C42.233,28.8,42.792,21.033,43.351,13.208ZM14.307,33.1c2.757-3.353,5.458-6.632,8.2-9.985,2.217,3.689,4.4,7.321,6.632,11.029C24.181,33.812,19.3,33.458,14.307,33.1Zm20.828,1.434c-1.192-.075-2.385-.149-3.577-.261a.777.777,0,0,1-.54-.317c-.727-1.118-1.434-2.236-2.142-3.372-.075-.112-.149-.354-.075-.428.82-1.006,1.639-2.012,2.515-3.055,1.509,2.478,2.981,4.918,4.508,7.433C35.545,34.539,35.34,34.558,35.135,34.539Zm4.993.354c-.708-.056-1.379-.093-2.031-.186-.149-.019-.317-.224-.41-.373l-5.868-9.613c-.093-.149-.186-.279-.3-.466-1.211,1.49-2.4,2.943-3.651,4.471-1.751-2.832-3.484-5.626-5.235-8.476-.894,1.1-1.733,2.142-2.589,3.186-2.44,3.018-4.881,6.017-7.321,9.054a.965.965,0,0,1-.894.41c-.578-.037-1.136-.019-1.788-.019.466-6.8.913-13.488,1.379-20.213,10.1.708,20.138,1.4,30.217,2.105C41.115,21.5,40.631,28.186,40.128,34.893Zm-5.533-13.86c1.025,0,1.546-.652,1.528-1.9,0-.894-.671-1.453-1.733-1.453a1.743,1.743,0,0,0-1.6,1.863C32.788,20.492,33.458,21.033,34.595,21.033Z"></path>
              </svg>
            </label>
            <div className="error small">{this.state.image_error}</div>
          </div>

          <button type="submit" className="btn primary">
            <span>送信</span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </button>
        </div>
        <textarea
          placeholder="メッセージを入力して下さい。"
          onChange={this._handleMessageChange.bind(this)}
          value={this.state.message}
        >
        </textarea>
      </form>
    )
  }
}

// export default ChatForm

// function mapStateToProps ({ activeChat }) {
//   return { activeChat }
// }
export default connect(null, { postChatMessage, postChatImage })(ChatForm)



// WEBPACK FOOTER //
// ./src/components/Chat/ChatForm.js